export default __webpack_public_path__ + "static/logo-bda8d5ab336b5d14d9ff68cb533c686a.svg";